export default __webpack_public_path__ + "static/SRUS P147 - Especification Del Producto y Datos Técnicos-9a8e717e984ddaced39ae8ca1c44fae4.pdf";